var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" }, props),
    React.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-error"] || "oc-icon-status-error"), d: "M14.1 0H5.9L0 5.9v8.3L5.9 20h8.3l5.9-5.9V5.9l-6-5.9zm.6 13.2c.4.3.3 1 0 1.4-.3.4-1 .4-1.4 0L10 11.4l-3.2 3.2c-.3.4-1 .3-1.4 0-.4-.3-.4-1 0-1.4L8.6 10 5.3 6.8c-.4-.3-.3-1 0-1.4.3-.4 1-.4 1.4 0L10 8.6l3.2-3.2c.3-.4 1-.3 1.4 0 .4.3.4 1 0 1.4L11.4 10l3.3 3.2z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Critical.svg